export const blockIconsPhotoandimageWbSunnyNew = (
	<span className='material-symbols-outlined'>wb_sunny</span>
);
